module.exports = __webpack_public_path__ + "static/media/breakout-lite.a4d778a2.gif";


//////////////////
// WEBPACK FOOTER
// ./src/images/breakout-lite.gif
// module id = 248
// module chunks = 0